export default __webpack_public_path__ + "static/media/Fredoka-Bold.631654ab.ttf";